module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "confirm-layout"
  }, [_c('div', {
    staticClass: "alert alert-success"
  }, [_c('span', [_vm._v("此藥物總存量:  " + _vm._s(_vm.selectedDrugTotalAmount))]), _c('span', {
    staticClass: "float-right"
  })]), (_vm.currentProgress === 'rxCheck') ? _c('RxCheckBarcode', {
    on: {
      "confirmRx": _vm.confirmRx
    }
  }) : _vm._e(), (_vm.currentProgress === 'actionWrap') ? _c('ActionWrap', {
    attrs: {
      "actionProgress": _vm.actionProgress,
      "medRecordId": _vm.currentSchedule.patient.med_record_number,
      "amount": _vm.currentDrug.amount,
      "scheduleId": _vm.currentSchedule.id,
      "reviewer": _vm.reviewer
    },
    on: {
      "setActionData": _vm.getFetchData
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7147627c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ScheduleFlow/ConfirmFlow.vue
// module id = 1508
// module chunks = 1